import React from "react";
import { BlockLayout } from '../BlockLayout';
import { Image } from 'components/Elements';

export const ImageBlock = ({ title, image, size }) => (
    <BlockLayout title={title} stacked={size === 'large'}>
        <Image {...image} />
    </BlockLayout>
)